import { Skeleton } from '@/shared/components/Skeleton';

/** What a guard shows while the session (and its two-step level) is read. */
export function AuthLoading(): JSX.Element {
  return (
    <div className="min-h-screen bg-[var(--color-bg)] flex items-center justify-center" aria-busy="true">
      <div className="space-y-4 w-full max-w-md p-5">
        <Skeleton width="60%" height={28} rounded="sm" />
        <Skeleton width="100%" height={16} rounded="sm" />
        <Skeleton width="100%" height={200} rounded="md" />
      </div>
    </div>
  );
}
